module.exports = __webpack_public_path__ + "static/media/programmare-è-difficile-molto.10fa1d18.md";